export default "__VITE_ASSET__1fb17053__";